module.exports = __webpack_public_path__ + "img/logo.a6094fc6.svg";